import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

// Dropdown data
const dropdownItems = {
  COUNTRY: [
    "SOUTH AFRICA", "Kenya", "Nigeria", "South Africa", "Uganda", "Ghana", "Ethiopia",
    "Tanzania", "Zimbabwe", "Egypt", "Morocco", "Senegal", "Zambia", "Cameroon",
    "Cote d'Ivoire", "Algeria", "Mozambique", "Rwanda", "Botswana", "Mali",
  ],
  REGION: Array(30).fill("GAUTENG"),
  ESG: ["Environment", ...Array(70).fill("ABBATOIR")],
  CROP: [
    "MAIZE", "Apples", "Avocado", "Bananas", "Beans", "Cabbages", "Kale",
    "Mangoes", "Onions", "Passion Fruits", "Papaya", "Potatoes", "Strawberries",
    "Tomatoes", "Watermelon",
  ],
  LIVESTOCK: Array(30).fill("POULTRY"),
  REPORT: ["PRODUCTION", "Revenue", "Inventory"],
};

// Dropdown Component
const Dropdown = ({ label, items, type }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(items[0]);

  return (
    <div className="flex flex-col w-fit relative">
      {/* Top label stays same */}
      <label className="md:text-[24px] font-bold md:mt-0 mt-2 text-[6px] text-black md:mb-1">
        {label}
      </label>

      <div className="flex relative z-20 w-fit">
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="xl:w-[165px] lg:w-[140px] md:w-[55px] w-[40px] h-[15px] md:h-[45px] bg-[#2E453D] text-white font-bold flex justify-between items-center px-1 rounded-l-[10px]"
        >
          <span className="md:text-[14px] md:px-4 text-[4px] md:mt-0 mt-[2px]">
            {selected}
          </span>
        </button>

        <div
          className="w-[20px] h-[15px] md:h-[45px] md:w-[40px] bg-[#152C24] flex justify-center items-center rounded-[10px] -ml-2 z-30 cursor-pointer"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
            alt="expand"
            className="w-3 h-3 md:w-5 md:h-5"
          />
        </div>
      </div>

     <AnimatePresence>
        {isOpen && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-full mt-1 left-0 z-50 md:w-[180px] w-[100px] bg-white/90 rounded-lg shadow-lg"
          >
            {items.map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  setSelected(item);
                  setIsOpen(false);
                }}
                className="md:p-3 p-1 bg-[#CFD7D7] md:mt-1 md:text-[18px] text-[10px] rounded-md hover:bg-[#afafaf] cursor-pointer flex items-center"
              >
                <span className="text-black">{item}</span>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>

      {/* Bottom helper text changes ONLY for 'Type of Report' */}
      <p className="md:text-[14px] text-[6px] font-normal mt-1 text-black">
  {label === "Report"
    ? "Select data type"
    : `Select ${label === "ESG" ? "ESG" : label.toLowerCase()}`}
</p>

    </div>
  );
};

// Wrapper component
const EsgDropdown = () => {
  const dropdownKeys = Object.keys(dropdownItems);
  const labelOverrides = {
    CROP: "Crop ",
    LIVESTOCK: "Livestock ",
   COUNTRY: "COUNTRY ",
    REPORT: "Report",
  };

  return (
    <div className="flex md:gap-2 gap-[1px] flex-wrap">
      {dropdownKeys.map((key) => (
        <Dropdown
          key={key}
          label={labelOverrides[key] || key}
          items={dropdownItems[key]}
          type={key}
        />
      ))}
    </div>
  );
};

export default EsgDropdown;
